module.exports = __webpack_public_path__ + "img/tcv_parked.a9e891a8.svg";